<div [formGroup]="registerForm">
  <label for="localeInput" class="form-label" translate="field.locale"></label>
  <select class="form-select" formControlName="locale" id="localeInput">
    <option *ngFor="let locale of locales" [value]="locale">{{ 'locale.' + locale | translate }}</option>
  </select>
</div>
